module.exports = __webpack_public_path__ + "img/30.8513a26d.gif";